import React from "react"
import Hero from "./Hero"
import CaseStudySection from "./CaseStudySection"
import Footer from "components/Footer"
import Contact from "components/Contact"
import CaseStudyProvider from "components/CaseStudyProvider"
import { Helmet } from "react-helmet"

class CaseStudies extends React.Component {
  render() {
    return (
      <main>
        <Helmet>
          <title>Case Studies</title>
          <meta
            name="description"
            content="Här hittar du ett urval av case studies från några av våra tidigare utförda projekt."
          />
        </Helmet>
        <Hero />
        <CaseStudyProvider
          render={caseStudies => {
            return caseStudies
              .filter(x => x.featuredOnCaseStudiesPage)
              .map((caseStudy, i) => (
                <CaseStudySection
                  key={caseStudy.id}
                  caseStudy={caseStudy}
                  variant={i % 2 && "light"}
                />
              ))
          }}
        />
        <Contact />
        <Footer />
      </main>
    )
  }
}

export default CaseStudies



// WEBPACK FOOTER //
// ./src/pages/CaseStudiesPage/index.jsx